export const LOGOS = {
  IeltsLogoUrl: 'https://bccdn.britishcouncil.org/logos/products/IELTS_logo.svg',
  EventPlannerLogoUrl: 'https://bccdn.britishcouncil.org/logos/apps/PLAN-IELTS.svg',
  PlanExamsLogoUrl: 'https://bccdn.britishcouncil.org/logos/apps/PLAN-IELTS.svg',
};
